<template>
  <div id="accordion" class="w-100">
    <template v-if="!qty">
        <div v-for="(item,user_id) in campaigns" :key="user_id">
          <ItemMonitor
            :stats="campaigns"
            :type="'campaigns'"
            :ref="user_id"
            :user_id="user_id"
            :target_id="orderId"
          ></ItemMonitor>
      </div>
    </template>
    <template v-else>
        <div v-if="order">
          <div v-if="hasData()">

            <Tooltip
              :text="'Awaiting creation emails'"
              :width="'130px'"
            >
              <i class="icon-circle text-ligth"> </i>
              <span class="ml-2">{{ order.prospectors_total }}</span>
            </Tooltip>
          </div>
          <div v-else>
              <span v-if="order.prospectors_warmingup !='0'" class="ml-0">

                <Tooltip
                  :text="'Warming-up emails'"
                  :width="'130px'"
                >
                  <i class="icon-circle text-warning "></i>
                  <span class="ml-0">{{ order.prospectors_warmingup }}</span>
                </Tooltip>
              </span>
              <span v-if="order.prospectors_active !='0'" class="ml-2">
                 <Tooltip
                    :text="'Ready-to-use emails'"
                    :width="'130px'"
                  >
                    <i class="icon-circle text-success "></i>
                    <span class="ml-2">{{ order.prospectors_active }}</span>
                 </Tooltip>
              </span>
              <span v-if="order.prospectors_resting !='0'" class="ml-2">
                <i class="icon-circle text-danger "></i>
                <span class="ml-2">{{ order.prospectors_resting }}</span>
              </span>
          </div>

        </div>
        <div v-else>
          <span v-if="total">
              <div  v-if="totals.success">
                <Tooltip
                    :text="'Active campaigns'"
                    :width="'130px'"
                  >
                  <i class="icon-circle text-success "></i>
                  <span class="ml-2">{{ totals.success }}</span>
                </Tooltip>
              </div>
              <div  v-if="totals.campaign_status_1">
                  <Tooltip
                    :text="'Pending campaigns'"
                    :width="'130px'"
                  >
                    <i class="icon-circle text-secondary "></i>
                    <span class="ml-2">{{ totals.campaign_status_1 }}</span>
                  </Tooltip>
              </div>
              <div  v-if="totals.campaign_status_3">
                <Tooltip
                    :text="'Stopped campaigns'"
                    :width="'130px'"
                  >
                  <i class="icon-circle text-danger "></i>
                  <span class="ml-2">{{ totals.campaign_status_3 }}</span>
                </Tooltip>
              </div>
              <div  v-if="totals.warning_apollo">
                  <i class="icon-circle text-warning "></i>
                  <span class="ml-2">{{ totals.warning_apollo }}</span>
              </div>
          </span>
        </div>
    </template>

  </div>
</template>

<script>

import Vue from "vue";
import { targetsService, usersService } from "@/_services";
import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  data () {
    return {
      campaigns:[],
      total: 0,
      totals: {
        campaign_status_1: 0,
        campaign_status_3: 0,
        quantity_per_day: 0,
        warning_apollo: 0,
        success: 0,
      }
    }
  },

  props: {
    orderId:String,
    qty: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    }
  },

  components: { ItemMonitor, Tooltip },


  created() {
      targetsService.getCampaignForOrder(this.orderId).then((responseCampaign) => {
        this.campaigns = responseCampaign
        this.total = Object.keys(this.campaigns).length;

        for (const key in this.campaigns) {
          if (this.campaigns.hasOwnProperty(key)) {
            const campaign_status_id = Object.values(this.campaigns[key]["campaign_status"])[0];
            const quantity_per_day = Object.values(this.campaigns[key]["quantity_per_day"])[0];
            const warning_apollo = Object.values(this.campaigns[key]["warning_apollo"])[0];

            this.sumTotal(campaign_status_id,quantity_per_day,warning_apollo);
          }
        }
      })
  },
  methods:{
    hasData(){
      if ( this.order.prospectors_warmingup == '0' &&
           this.order.prospectors_active == '0' &&
           this.order.prospectors_resting == '0' &&
           this.order.prospectors_total != '0') {
            return true;
           } else {
            return false;
           }
    },
    sumTotal(campaign_status_id, quantity_per_day, warning_apollo) {
          if (campaign_status_id == 3) {
              this.totals.campaign_status_3 = this.totals.campaign_status_3 + 1
              return
          }
          if (campaign_status_id == 1) {
            this.totals.campaign_status_1 = this.totals.campaign_status_1 + 1
              return
          }
          if (quantity_per_day == 0) {
            this.totals.quantity_per_day = this.totals.quantity_per_day + 1
            return
          }
          if (warning_apollo) {
            this.totals.warning_apollo = this.totals.warning_apollo + 1
            return
          }
          this.totals.success = this.totals.success + 1
          return
    },
  }

};
</script>
